import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  selectedPatientId: null,
}

const consultationSlice = createSlice({
  name: "consultation",
  initialState,
  reducers: {
    setSelectedPatientId: (state, action) => {
      state.selectedPatientId = action.payload
    },
    clearSelectedPatientId: (state) => {
      state.selectedPatientId = null
    },
  },
})

export const { setSelectedPatientId, clearSelectedPatientId } =
  consultationSlice.actions
export default consultationSlice.reducer
